export const getBorrowerNames = (borrowerFirstName: string, coBorrowerFirstName?: string | null) => {
  return borrowerFirstName + (!!coBorrowerFirstName ? ` and ${coBorrowerFirstName}` : '');
};
